<template>
  <div>
    <div class="row header">
      <div class="col s12"><span class="title">{{ title }}</span></div>
    </div>
    <div v-for="item in data" class="row content" :key="item.label">
      <div :class="{col: true, s5: true, property: true, disabled: item.disabled }">{{ item.label }}:</div>
      <div class="col s7 disabled" v-if="item.disabled">&nbsp;</div>
      <div class="col s7 list" v-else-if="item.multiple">
        <div v-for="(l, index) in item.list" class="row content" :key="l.value + index">
          <div class="col s12">{{ l.value }}</div>
        </div>
      </div>
      <div class="col s7 children" v-else-if="item.parent">
        <div v-for="c in item.children" class="row content" :key="c.label">
          <div :class="{col: true, s3: true, property: true, disabled: c.disabled }">{{ c.label }}:</div>
          <div class="col s9 value">{{ !c.disabled ? c.value : '&nbsp;' }}</div>
        </div>
      </div>
      <div class="col s7 value" v-else>{{ item.value }}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'InfoColumn',
  props: {
    data: {},
    title: {}
  }
}
</script>

<style scoped>
  .title {
    padding-left: 15px;
    font-family: Roboto;
    font-style: normal;
    font-weight: 500;
    font-size: 20px;
    line-height: 23px !important;
    color: rgba(0, 0, 0, 0.87);
  }

  .property {
    text-align: right;
    font-weight: bold;
  }

  .disabled {
    color: lightgrey;
  }

  .content {
    margin-bottom: 5px;
  }
</style>



// WEBPACK FOOTER //
// src/components/switch/InfoColumn.vue